import React from "react";
import styled from "styled-components";
import usePageTitle from "./hooks/usePageTitle";
import Header from "./components/Header";
import Welcome from "./components/Welcome";
import Home from "./components/Home";
import About from "./components/About";
import Products from "./components/Products";
import Technology from "./components/Technology";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import GlobalStyles from "./styles/GlobalStyles";

const AppContainer = styled.div`
  min-height: 100vh;
  font-family: "Inter", sans-serif;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
`;

const Section = styled.section`
  scroll-margin-top: 80px; /* Account for fixed header */
  position: relative;
`;

function App() {
  // Set the main page title and description
  usePageTitle(
    "ASKK International - Empowering Women's Health & Confidence",
    "ASKK International - Leading provider of premium sanitary products with Anion Chip Technology and Aloe Vera Papaya Gelly for women's health and confidence."
  );

  return (
    <>
      <GlobalStyles />
      <AppContainer>
        <Header />
        <MainContent>
          {/* Welcome Section */}
          <Section id="welcome">
            <Welcome />
          </Section>
          
          {/* Home Section */}
          <Section id="home">
            <Home />
          </Section>
          
          {/* Gallery Section */}
          <Section id="gallery">
            <Gallery />
          </Section>
          
          {/* Products Section */}
          <Section id="products">
            <Products />
          </Section>
          
          {/* Technology Section */}
          <Section id="technology">
            <Technology />
          </Section>
          
          {/* About Section */}
          <Section id="about">
            <About />
          </Section>
          
          {/* Contact Section */}
          <Section id="contact">
            <Contact />
          </Section>
        </MainContent>
        <Footer />
      </AppContainer>
    </>
  );
}

export default App;
